import React, { Component, PropTypes } from 'react';
import { Col, FormGroup } from 'react-bootstrap';
import CarryingGoods from '../../carryingGoods/CarryingGoods';
import BodyType from '../../bodyType/BodyType';
import Usage from '../../usage/Usage';
import Make from '../../quotationCVComponent/make/Make';
import Model from '../../quotationCVComponent/model/Model';
import SeatingCapacity from '../../quotationCVComponent/seatingCapacity/SeatingCapacity';
import YearOfManufacture from '../../quotationCVComponent/yearOfManufacture/YearOfManufacture';
import VehicleRegNo from '../../vehicleRegNo/VehicleRegNo'
import Tonnage from '../../tonnage/Tonnage';
import EngineNo from '../../engineNo/EngineNo';
import ChassisNo from '../../chassisNo/ChassisNo';
import BusinessOccupationType from '../../businessOccupationType/BusinessOccupationType';
import Description from '../../description/Description';

class ParticularOfVehicle extends Component {

  constructor(props) {
    super(props);
    this.state = {
      option: [],
      YOMRequired: true
    }
  }

  render() {
    return (
      <div className="ebaoUtil__Top-Bottom-Line">
        <h3 className="ebaoUtil__HeaderThree">Particular of Vehicle</h3>
          <FormGroup controlId="carryingGoods">
            <Col sm={6}>
              <CarryingGoods
                handleChangeCarryingGoods={this.props.handleChangeParticularOfVehicle}
                carryingGoods={this.props.particularOfVehicle.carryingGoods}
              />
            </Col>
            <Col sm={6} />
          </FormGroup>
          <FormGroup controlId="makeModel">
            <Col sm={6}>
              <Make
                handleChangeMake={this.props.handleChangeParticularOfVehicle}
                calculation={this.props.calculation}
                make={this.props.particularOfVehicle.make}
              />
            </Col>
            <Col sm={6}>
              <Model
                option={this.props.option}
                handleChangeModel={this.props.handleChangeParticularOfVehicle}
                calculation={this.props.calculation}
                model={this.props.particularOfVehicle.model}
              />
            </Col>
          </FormGroup>
          <FormGroup controlId="bodyTypeUsage">
            <Col sm={6}>
              <BodyType
                handleChangeBodyType={this.props.handleChangeParticularOfVehicle}
                bodyType={this.props.particularOfVehicle.bodyType}
              />
            </Col>
            <Col sm={6}>
              <Usage
                usage={this.props.particularOfVehicle.usage}
                handleChangeUsage={this.props.handleChangeParticularOfVehicle}
              />
            </Col>
          </FormGroup>
          <FormGroup controlId="tonnageSeatingCap">
            <Col sm={6}>
              <Tonnage
                tonnage={this.props.particularOfVehicle.tonnage}
                handleChangeTonnage={this.props.handleChangeParticularOfVehicle}
                calculation={this.props.calculation}
              />
            </Col>
            <Col sm={6}>
              <SeatingCapacity
                seatingCap={this.props.particularOfVehicle.seatingCap}
                handleChangeSeatingCap={this.props.handleChangeParticularOfVehicle}
                validation={this.props.validation}
              />
            </Col>
          </FormGroup>
          <FormGroup controlId="yearOfManufactureVehicleRegNo">
            <Col sm={6}>
              <YearOfManufacture
                yearOfManufacture={this.props.particularOfVehicle.yearOfManufacture}
                handleChangeYearOfManufacture={this.props.handleChangeParticularOfVehicle}
                calculation={this.props.calculation}
                required={this.state.YOMRequired}
              />
            </Col>
            <Col sm={6}>
              <VehicleRegNo
                vehicleRegNo={this.props.particularOfVehicle.vehicleRegNo}
                handleChangeVehicleRegNo={this.props.handleChangeParticularOfVehicle}
                validation={this.props.validation}
              />
            </Col>
          </FormGroup>
          <FormGroup controlId="engineNoChassisNo">
            <Col sm={6}>
              <EngineNo
                engineNo={this.props.particularOfVehicle.engineNo}
                handleChangeEngineNo={this.props.handleChangeParticularOfVehicle}
              />
            </Col>
            <Col sm={6}>
              <ChassisNo
                chassisNo={this.props.particularOfVehicle.chassisNo}
                handleChangeChassisNo={this.props.handleChangeParticularOfVehicle}
              />
            </Col>
          </FormGroup>
          <FormGroup controlId="busTypeDescription">
            <Col sm={6}>
              <BusinessOccupationType
                busType={this.props.particularOfVehicle.busType}
                handleChangeBusType={this.props.handleChangeParticularOfVehicle}
              />
            </Col>
            <Col sm={6}>
              <Description
                description={this.props.particularOfVehicle.description}
                handleChangeDescription={this.props.handleChangeParticularOfVehicle}
              />
            </Col>
          </FormGroup>
      </div>
    )
  }
}

ParticularOfVehicle.propTypes = {
  particularOfVehicle: PropTypes.object,
  handleChangeParticularOfVehicle: PropTypes.func,
  option: PropTypes.array,
  calculation: PropTypes.func,
  validation: PropTypes.func
};

export default ParticularOfVehicle;



// WEBPACK FOOTER //
// ./src/app/components/quotationCVComponent/particularOfVehicle/ParticularOfVehicle.js